/**
 * A loyalty redemption never exceeds what the bill can absorb (owner ruling
 * 2026-10-10), the same rule as the POS till and the server quote: the order
 * records only the value used, and only its share of points/cashback is burned
 * (points rounded up to a whole point).
 */
export type RedemptionOptionLike = {
  type?: string | null;
  maxRedeemable?: number | null;
  redeemableValue?: number | null;
} | null | undefined;

export type CappedRedemption = { value: number; points: number; cashback: number };

const r2 = (n: number) => Math.round(n * 100) / 100;

export function capRedemption(option: RedemptionOptionLike, billBeforeLoyalty: number): CappedRedemption {
  const full = option?.redeemableValue ?? 0;
  const burn = option?.maxRedeemable ?? 0;
  if (!option || full <= 0 || billBeforeLoyalty <= 0) return { value: 0, points: 0, cashback: 0 };
  const value = r2(Math.min(full, billBeforeLoyalty));
  const isPoints = option.type === "points";
  if (value >= full) {
    return isPoints ? { value, points: Math.floor(burn), cashback: 0 } : { value, points: 0, cashback: r2(full) };
  }
  if (!isPoints) return { value, points: 0, cashback: value };
  return { value, points: Math.ceil((burn * value) / full - 1e-9), cashback: 0 };
}
